import { template } from "@ember/template-compiler";
import { service } from 'ember-primitives/helpers';
import Create from './create';
import Footer from './footer';
function hasTodos(todos1) {
    return todos1.length > 0;
}
export default template(`
	<section class="todoapp">
		<header class="header">
			<h1>todos</h1>

			<Create />
		</header>

		{{yield}}

		{{#let (service "repo") as |repo|}}
			{{#if (hasTodos repo.all)}}
				<Footer />
			{{/if}}
		{{/let}}
	</section>
`, {
    eval () {
        return eval(arguments[0]);
    }
});
